const topics = [
  { label: '久久视频热播', count: '12.6万' },
  { label: '小蓝视频独家', count: '9.8万' },
  { label: '豆花视频免费', count: '8.3万' },
  { label: '高清不缓冲', count: '15.2万' },
  { label: '新剧抢先看', count: '7.1万' },
  { label: '经典老片', count: '6.5万' },
  { label: '日漫连载', count: '5.9万' },
  { label: '韩剧推荐', count: '5.4万' },
  { label: '悬疑烧脑', count: '4.8万' },
  { label: '喜剧合家欢', count: '4.2万' },
  { label: '纪录片精选', count: '3.7万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门话题</h2>
            <p className="text-sm md:text-base text-foreground-600">
              看看大家都在关注久久视频、小蓝视频、豆花视频的哪些内容
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic, i) => (
              <a
                key={i}
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 hover:bg-background-200 border border-background-200/70 hover:border-primary-200 rounded-full transition-all duration-200 cursor-pointer no-underline group"
              >
                <span className="text-sm text-foreground-800 group-hover:text-primary-600 transition-colors">{topic.label}</span>
                <span className="text-xs text-foreground-500 bg-background-50 px-1.5 py-0.5 rounded-full">{topic.count}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}